export function HRDivider(props: { title: string }) {
    return (
      <div className="flex flex-row items-center justify-center p-0 mx-0 my-2">
        <div className="h-0.75 w-full bg-gray-300 flex-1"></div>
        <div className="px-2 text-xs font-semibold text-gray-400">{props.title}</div>
        <div className="h-0.75 w-full bg-gray-300 flex-1"></div>
      </div>
    );
  }